<script>
import { mapGetters, mapMutations } from 'vuex';
import Button from '@/components/Button.vue';
import Header from '@/components/Header.vue';
import TeamMember from '@/components/TeamMember.vue';
import MemberProfile from '@/components/MemberProfile.vue';
import ProjectItem from '@/components/ProjectItem.vue';
import ProjectDescription from '@/components/ProjectDescription.vue';
import store from '@/store/index';

export default {
  name: 'Home',
  store,
  computed: {
    // ...mapState(['projects']),
    ...mapGetters(['teamInOrder', 'selectedMember', 'selectedProject', 'projectsList', 'layout', 'showProjectPage']),
  },
  methods: {
    ...mapMutations(['selectMember', 'selectProject', 'deselectProject']),
  },
  props: {
    msg: String,
  },
  components: {
    ProjectItem,
    ProjectDescription,
    Button,
    Header,
    TeamMember,
    MemberProfile,
  },
};
</script>

<template>
  <div>
    <div class="screen first-screen">
      <Header
        mailto="support@glitchless.ru"
        vk="vk.me/team.glitchless"
        :two-row="layout.twoRowHeader"
      />
      <div class="controls">
        <div class="promo">
          <img class="promo__logo" src="../assets/logo.png" alt="Glitchless logo"/>
          <div class="promo__text-container">
            <div class="promo__name">glitchless</div>
            <div class="promo__text">
              Веб-разработка и не только
            </div>
          </div>
        </div>
      </div>
      <div class="first-screen__footer">
        <div class="first-screen__footer-btn">
          <Button href="#team" glitch-hover>
            Подробнее о нас
          </Button>
        </div>
      </div>
    </div>
    <div id="team" class="screen second-screen">
      <div class="second-screen__center">
        <div
          :class="{'team-select': true, 'team-select_column': layout.twoColumnTeam}"
        >
          <div class="team-select__bg">
          </div>
          <div class="team-select__content">
            <div class="team-select__title">
              Команда
            </div>
            <div class="team-select__list">
              <div
                class="team-select__member"
                v-for="member in teamInOrder"
                v-bind:key="member.nickname"
                v-on:click="selectMember(member.nickname)"
              >
                <TeamMember
                  v-bind="member"
                  :active="layout.twoColumnTeam && selectedMember.nickname === member.nickname"
                />
                <MemberProfile
                  v-if="!layout.twoColumnTeam"
                  :description="member.description"
                  :favourite="member.favourite"
                  :contacts="member.contacts"
                  light
                  centered
                />
              </div>
            </div>
          </div>
        </div>
        <div class="member-profile" v-if="layout.twoColumnTeam">
          <MemberProfile v-bind="selectedMember"/>
        </div>
      </div>
    </div>
    <div id="projects" class="screen third-screen">
      <div class="third-screen__center" v-if="layout.twoColumnProjects">
        <div class="projects">
          <div class="projects__content">
            <div class="projects__title">
              Наши проекты
            </div>
            <div class="projects__list">
              <div
                class="projects__project-select"
                v-for="project in projectsList"
                v-bind:key="project.name"
                v-on:click="selectProject(project.name)"
              >
                <ProjectItem v-bind="project" :active="selectedProject.name === project.name"/>
              </div>
            </div>
          </div>
        </div>
        <div class="project-description">
          <ProjectDescription v-bind="selectedProject"/>
        </div>
      </div>
      <div class="third-screen__center" v-else>
        <div
          :class="{projects: true, projects_mobile: true,
          'projects_mobile-column': layout.projectsColumn}"
        >
          <div class="projects__content" v-if="!showProjectPage">
            <div class="projects__title">
              Наши проекты
            </div>
            <div class="projects__list">
              <div
                class="projects__project-select"
                v-for="project in projectsList"
                v-bind:key="project.name"
                v-on:click="selectProject(project.name)"
              >
                <ProjectItem v-bind="project" :active="selectedProject.name === project.name"/>
              </div>
            </div>
          </div>
          <div class="project-description project-description_fullscreen" v-else>
            <div class="project-description__back">
              <Button @click="deselectProject()">
                <template #icon>
                  <i class="fas fa-chevron-left"></i>
                </template>
                <span>Назад</span>
              </Button>
            </div>
            <ProjectDescription v-bind="selectedProject" mobile/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .screen {
    height: 100vh;
  }

  .first-screen {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    min-height: 450px;

    background: var(--main-dark);
  }

  .second-screen {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    height: auto;

    z-index: -100;

    &__center {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;
      width: 100%;
      padding: 48px 12px;
      box-sizing: border-box;
    }
  }

  .third-screen {
    background: var(--main-dark);
    height: auto;

    &__center {
      display: flex;
      justify-content: space-evenly;
      width: 100%;
      padding: 84px 12px;
      box-sizing: border-box;
    }
  }

  .team-select {
    position: relative;
    transition: width 1s;

    &_column {
      min-width: 550px;
      max-height: 820px;

      .team-select__content {
        padding-left: 120px;
        margin-top: 80px;
      }
    }

    &__bg {
      background: var(--bg-dark-secondary);
      position: absolute;
      left: 0;
      right: 60px;
      bottom: 40px;
      top: 0;
      z-index: -1;
    }

    &__member {
      margin-bottom: 24px;
    }

    &__list {
    }

    &__title {
      text-align: center;
      padding: 24px 0;
      font-weight: bold;
      font-size: 36px;
      color: var(--main-bright);
    }
  }

  .member-profile {
    min-width: 500px;
    transition: width 1s;
  }

  .controls {
    display: flex;
  }

  .project-description {
    display: flex;
    align-items: center;
    flex-grow: 1;

    &_fullscreen {
      flex-direction: column;
      align-items: flex-start;
      padding: 0 20px;
    }

    &__back {
      margin-bottom: 36px;
    }
  }

  .projects {
    position: relative;
    min-width: 550px;
    transition: width 1s;
    display: flex;
    justify-content: center;

    &_mobile {
      min-width: 0;

      .projects__list {
        display: grid;
        grid-column-gap: 20px;
        grid-template-columns: 1fr 1fr;
      }
    }

    &_mobile-column {
      .projects__list {
        grid-template-columns: 1fr;
      }
    }

    &__content {
    }

    &__project-select {
      margin-bottom: 32px;
      cursor: pointer;
    }

    &__list {
    }

    &__title {
      text-align: center;
      padding: 24px 0;
      font-weight: bold;
      font-size: 36px;
      color: var(--main-bright);
    }
  }

  .first-screen__footer {
    display: flex;
    justify-content: center;
    bottom: 50px;
    width: 100%;

    &-btn {
      margin-bottom: 50px;
    }
  }

  .promo {
    display: flex;

    &__logo {
      width: 300px;
      height: 300px;
    }

    &__text-container {
      margin-left: 40px;
      margin-top: 60px;
      color: var(--main-bright);
    }

    &__name {
      font-size: var(--promo-name-font);
      font-weight: bold;
      text-align: center;
    }

    &__text {
      margin-top: 16px;
      font-size: 24px;
      max-width: 500px;
    }
  }

  @media(max-width: 800px) {
    .promo {
      flex-direction: column;
      align-items: center;

      &__text-container {
        margin-top: 0;
        margin-left: 0;
      }

      &__text {
        margin-top: 4px;
        text-align: center;
      }
    }

    .first-screen {
      height: auto;

      &__footer {
        margin-top: 20px;
      }
    }
  }

  @media (max-width: 1280px) {
    .second-screen {
      background: var(--bg-dark-secondary);
    }
  }
</style>
